export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8011.3f8788da.jpg";